<template>
    <div>
      <report-header @generate="load" @filterChanged="filterChanged"
        @onChangedDateStart="onChangedDateStart" @onChangedDateEnd="onChangedDateEnd" @onChangedGroup="onChangedGroup" @onChangedTypeTraffic="onChangedTypeTraffic"
        :filterOptions="filterOptions" :isGenerateDisabled="isGenerateDisabled" @paginationChanged="paginationChanged"
        @limitChanged="limitChanged"
        @download="download"
        @onChangeAccsGroup="onChangeAccsGroup"/>

      <basic-table
        @Filtred="Filtred"
        :items="traffic"
        :fields="trafficFields"
        :filter="filter"
        :perPage="perPage"
        :currentPage="currentPage"
        v-model="totalRows"/>
      <table-manager-bottom
        :totalRows="totalRows" :perPage="perPage"
        v-model="currentPage"/>
    </div>
</template>

<script>
import download from 'downloadjs'
export default {
  props: {
    userId: 0
  },
  data () {
    return {
      getStore: {
        numDateEnd: 0,
        numDateStart: 0,
        userId: 0,
        group_id: 0,
        accs_group_id: 0,
        type: 0,
        accounting_period_id: 0,
        account_id: 0,
        limit: 500,
        download: 0
      },
      traffic: [],
      trafficFields: [
        {key: 'account_id', label: this.$i18n.t('Account ID'), sortable: true},
        {key: 'login', label: this.$i18n.t('Login'), sortable: true},
        {key: 'date', label: this.$i18n.t('Date'), sortable: true, formatter: (val, key, item) => { return val === null ? this.$i18n.t('Not installed') : this.$root.showDataWithTZDelta(val) }},
        {key: 'tclass_name', label: this.$i18n.t('Traffic class'), sortable: true},
        {key: 'bytes', label: this.$i18n.t('MBytes'), sortable: true},
        {key: 'base_cost', label: this.$i18n.t('Cost per unit mb'), sortable: true},
        {key: 'charge',
          label: this.$i18n.t('Sum'),
          sortable: true,
          formatter: (val, key, item) => {
            return Number(val).toFixed(2)
          }},
        {key: 'ip', label: 'IP', sortable: true}
      ],
      isGenerateDisabled: false,
      selectTypeTraffic: 0,
      selectGroup: 0,
      selectAccsGroup: 0,
      filter: null,
      perPage: 20,
      totalRows: 0,
      currentPage: 1,
      dateStart: this.$root.setDataWithSelectedTZ().toDate(),
      dateEnd: this.$root.setDataWithSelectedTZ().toDate(),
      filterOptions: {
        isFilterGroup: true,
        isFilterAccsGroup: true,
        isFilterTypeTraffic: true,
        isFilterTypeDocuments: false,
        isFilterTypeUsers: false,
        isFilterCollector: false,
        isDownloadable: true,
        hasLimitRows: true
      }
    }
  },
  methods: {
    Filtred (items) {
      this.totalRows = items.length
    },
    async load (isGenClick = true) {
      this.isGenerateDisabled = true
      let numDateEnd = Number(this.dateEnd) / 1000
      if (numDateEnd > 2147483647) numDateEnd = 2147483647
      let numDateStart = Number(this.dateStart) / 1000
      if (numDateStart > 2147483647) numDateStart = 2147483647
      this.getStore.numDateEnd = numDateEnd
      this.getStore.numDateStart = numDateStart
      this.getStore.type = this.selectTypeTraffic
      if (!this.userId) {
        this.getStore.group_id = this.selectGroup
        this.getStore.accs_group_id = this.selectAccsGroup
      } else {
        this.getStore.userId = this.userId
      }
      await this.$store.dispatch('Reports/GET_TRAFFIC', this.getStore).then(response => {
        if (isGenClick) {
          this.traffic = this.$store.getters['Reports/TRAFFIC']
        } else {
          download(this.$store.getters['Reports/TRAFFIC'], 'report_services_traffic.csv', 'text/csv')
        }

        for (let el of this.traffic) {
          let Mbytes = el.bytes / 1024 / 1024
          el.bytes = Number.parseFloat(Mbytes).toFixed(3)
          el.charge = Number.parseFloat(el.charge).toFixed(2)
        }
      })
      this.loadDone()
    },
    download () {
      this.getStore.download = 1
      this.load(false)
      this.$store.dispatch('Reports/CLEAR_TRAFFIC')
      this.getStore.download = 0
      this.totalRows = 0
      this.traffic = []
    },
    limitChanged (limit) {
      this.getStore.limit = limit
    },
    onChangedDateStart (value) {
      this.dateStart = value
    },
    onChangedDateEnd (value) {
      this.dateEnd = value
    },
    onChangedGroup (value) {
      this.selectGroup = (value)
    },
    onChangeAccsGroup (value) {
      this.selectAccsGroup = value
    },
    onChangedTypeTraffic (value) {
      this.selectTypeTraffic = (value)
    },
    filterChanged (value) {
      this.filter = value
    },
    loadDone () {
      this.isGenerateDisabled = false
    },
    paginationChanged (value) {
      this.perPage = value
    },
    intToDate (val) {
      return this.$root.showDataWithTZDelta(val)
    }
  },
  mounted () {
    this.loadDone()
    if (this.userId) {
      this.filterOptions.isFilterGroup = false
      this.filterOptions.isFilterAccsGroup = false
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/pages/reports/services/traffic/main.vue